var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 1.7.22")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 128) scale(0.72 0.72)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(-175.05 -175.05) scale(3.89 3.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 45 61.605 c -0.181 0 -0.363 -0.049 -0.523 -0.147 c -2.179 -1.337 -3.587 -4.844 -3.587 -8.935 c 0 -2.052 0.361 -4.001 1.044 -5.638 c 0.156 -0.372 0.52 -0.614 0.923 -0.614 h 4.285 c 0.403 0 0.768 0.242 0.923 0.614 c 0.683 1.635 1.044 3.584 1.044 5.638 c 0 4.091 -1.408 7.598 -3.586 8.935 C 45.363 61.557 45.181 61.605 45 61.605 z M 43.548 48.271 c -0.427 1.258 -0.658 2.742 -0.658 4.252 c 0 3.329 1.016 5.717 2.11 6.809 c 1.093 -1.092 2.109 -3.479 2.109 -6.809 c 0 -1.512 -0.231 -2.995 -0.658 -4.252 H 43.548 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(248,134,15)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 84.837 c -0.552 0 -1 -0.447 -1 -1 V 67.099 c 0 -0.553 0.448 -1 1 -1 s 1 0.447 1 1 v 16.738 C 46 84.39 45.552 84.837 45 84.837 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(248,134,15)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 35.564 75.813 c -0.552 0 -1 -0.447 -1 -1 V 55.479 c 0 -0.553 0.448 -1 1 -1 s 1 0.447 1 1 v 19.335 C 36.564 75.366 36.117 75.813 35.564 75.813 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(248,134,15)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 54.436 77.511 c -0.553 0 -1 -0.447 -1 -1 V 57.176 c 0 -0.553 0.447 -1 1 -1 s 1 0.447 1 1 v 19.335 C 55.436 77.063 54.988 77.511 54.436 77.511 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(248,134,15)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65.67 10.139 h -1.164 c -0.553 0 -1 -0.448 -1 -1 s 0.447 -1 1 -1 h 1.164 c 0.553 0 1 0.448 1 1 S 66.223 10.139 65.67 10.139 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(248,134,15)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 71.506 10.139 h -1.165 c -0.553 0 -1 -0.448 -1 -1 s 0.447 -1 1 -1 h 1.165 c 0.553 0 1 0.448 1 1 S 72.059 10.139 71.506 10.139 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(248,134,15)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 68.006 7.803 c -0.553 0 -1 -0.448 -1 -1 V 5.639 c 0 -0.552 0.447 -1 1 -1 s 1 0.448 1 1 v 1.164 C 69.006 7.355 68.559 7.803 68.006 7.803 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(248,134,15)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 68.006 13.639 c -0.553 0 -1 -0.448 -1 -1 v -1.165 c 0 -0.552 0.447 -1 1 -1 s 1 0.448 1 1 v 1.165 C 69.006 13.191 68.559 13.639 68.006 13.639 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(248,134,15)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10.159 51.139 H 8.994 c -0.552 0 -1 -0.447 -1 -1 s 0.448 -1 1 -1 h 1.165 c 0.552 0 1 0.447 1 1 S 10.711 51.139 10.159 51.139 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(248,134,15)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15.994 51.139 H 14.83 c -0.552 0 -1 -0.447 -1 -1 s 0.448 -1 1 -1 h 1.165 c 0.552 0 1 0.447 1 1 S 16.546 51.139 15.994 51.139 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(248,134,15)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.494 48.803 c -0.552 0 -1 -0.447 -1 -1 v -1.164 c 0 -0.553 0.448 -1 1 -1 s 1 0.447 1 1 v 1.164 C 13.494 48.355 13.046 48.803 12.494 48.803 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(248,134,15)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.494 54.639 c -0.552 0 -1 -0.447 -1 -1 v -1.165 c 0 -0.553 0.448 -1 1 -1 s 1 0.447 1 1 v 1.165 C 13.494 54.191 13.046 54.639 12.494 54.639 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(248,134,15)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 81.22 61.609 c -0.13 0 -0.26 -0.02 -0.38 -0.069 s -0.23 -0.13 -0.33 -0.221 c -0.09 -0.1 -0.16 -0.199 -0.22 -0.329 c -0.05 -0.12 -0.07 -0.25 -0.07 -0.381 c 0 -0.26 0.11 -0.52 0.29 -0.71 c 0.37 -0.369 1.05 -0.369 1.42 0 c 0.18 0.19 0.29 0.45 0.29 0.71 c 0 0.131 -0.03 0.261 -0.08 0.381 c -0.05 0.13 -0.12 0.239 -0.21 0.329 c -0.1 0.091 -0.21 0.171 -0.33 0.221 S 81.35 61.609 81.22 61.609 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(248,134,15)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 52.436 48.271 H 37.564 c -0.403 0 -0.767 -0.242 -0.923 -0.614 c -2.246 -5.376 -3.433 -11.812 -3.433 -18.611 c 0 -13.15 4.528 -24.764 11.269 -28.899 c 0.321 -0.196 0.725 -0.196 1.046 0 c 6.74 4.135 11.268 15.749 11.268 28.899 c 0 6.801 -1.188 13.236 -3.433 18.611 C 53.203 48.029 52.839 48.271 52.436 48.271 z M 38.237 46.271 h 13.525 c 1.982 -5.007 3.028 -10.946 3.028 -17.225 c 0 -11.93 -3.999 -22.82 -9.791 -26.852 c -5.792 4.032 -9.792 14.921 -9.792 26.852 C 35.208 35.324 36.254 41.263 38.237 46.271 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,35,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 27.929 53.817 c -0.173 0 -0.346 -0.045 -0.5 -0.135 c -0.309 -0.179 -0.5 -0.508 -0.5 -0.865 v -9.738 c 0 -0.208 0.064 -0.41 0.185 -0.579 l 6.498 -9.153 c 0.243 -0.341 0.675 -0.495 1.077 -0.386 c 0.404 0.109 0.698 0.459 0.735 0.877 c 0.422 4.748 1.481 9.259 3.064 13.048 c 0.194 0.465 0.012 1.001 -0.424 1.252 l -9.636 5.546 C 28.273 53.772 28.101 53.817 27.929 53.817 z M 28.929 43.398 v 7.69 l 7.383 -4.249 c -1.195 -3.072 -2.073 -6.545 -2.583 -10.203 L 28.929 43.398 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,35,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62.071 53.817 c -0.172 0 -0.345 -0.044 -0.499 -0.134 l -9.636 -5.546 c -0.437 -0.251 -0.618 -0.787 -0.424 -1.252 c 1.583 -3.79 2.644 -8.302 3.064 -13.048 c 0.037 -0.417 0.33 -0.768 0.734 -0.877 c 0.405 -0.111 0.835 0.045 1.077 0.386 l 6.498 9.153 c 0.12 0.169 0.185 0.372 0.185 0.579 v 9.738 c 0 0.357 -0.19 0.687 -0.499 0.865 C 62.417 53.772 62.244 53.817 62.071 53.817 z M 53.688 46.839 l 7.383 4.249 v -7.69 l -4.8 -6.761 C 55.763 40.293 54.884 43.766 53.688 46.839 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,35,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 30.885 c -3.712 0 -6.731 -3.02 -6.731 -6.731 s 3.02 -6.731 6.731 -6.731 s 6.731 3.02 6.731 6.731 S 48.712 30.885 45 30.885 z M 45 19.422 c -2.609 0 -4.731 2.123 -4.731 4.731 s 2.123 4.731 4.731 4.731 c 2.609 0 4.731 -2.123 4.731 -4.731 S 47.609 19.422 45 19.422 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,35,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76.741 90 H 13.259 C 8.735 90 4.94 86.446 4.8 82.078 c -0.116 -3.604 2.183 -6.87 5.551 -8.018 c 1.131 -7.771 7.766 -13.55 15.7 -13.55 c 0.936 0 1.873 0.082 2.784 0.244 c 0.544 0.097 0.906 0.615 0.81 1.159 c -0.097 0.543 -0.617 0.906 -1.159 0.81 c -0.796 -0.142 -1.615 -0.213 -2.434 -0.213 c -7.132 0 -13.063 5.343 -13.794 12.427 c -0.043 0.42 -0.345 0.768 -0.755 0.868 c -2.819 0.695 -4.796 3.307 -4.703 6.208 C 6.905 85.314 9.803 88 13.259 88 h 63.482 c 3.456 0 6.354 -2.686 6.46 -5.986 c 0.093 -2.901 -1.884 -5.513 -4.702 -6.208 c -0.41 -0.101 -0.712 -0.448 -0.756 -0.868 c -0.731 -7.084 -6.662 -12.427 -13.794 -12.427 c -0.818 0 -1.638 0.071 -2.434 0.213 c -0.539 0.101 -1.063 -0.266 -1.159 -0.81 s 0.266 -1.063 0.81 -1.159 c 0.911 -0.162 1.848 -0.244 2.783 -0.244 c 7.934 0 14.568 5.778 15.7 13.55 c 3.367 1.147 5.667 4.413 5.55 8.018 C 85.06 86.446 81.265 90 76.741 90 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,35,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17.753 21.391 c -1.921 0 -3.484 -1.563 -3.484 -3.484 c 0 -1.921 1.563 -3.484 3.484 -3.484 c 1.921 0 3.484 1.563 3.484 3.484 C 21.237 19.828 19.674 21.391 17.753 21.391 z M 17.753 16.422 c -0.818 0 -1.484 0.666 -1.484 1.484 s 0.666 1.484 1.484 1.484 s 1.484 -0.666 1.484 -1.484 S 18.571 16.422 17.753 16.422 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,35,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 77.72 44.837 c -1.921 0 -3.484 -1.563 -3.484 -3.484 c 0 -1.921 1.563 -3.484 3.484 -3.484 s 3.484 1.563 3.484 3.484 C 81.204 43.274 79.641 44.837 77.72 44.837 z M 77.72 39.869 c -0.818 0 -1.484 0.666 -1.484 1.484 s 0.666 1.484 1.484 1.484 s 1.484 -0.666 1.484 -1.484 S 78.538 39.869 77.72 39.869 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,35,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.22 34.61 c -0.13 0 -0.26 -0.02 -0.38 -0.07 c -0.13 -0.06 -0.23 -0.13 -0.33 -0.22 c -0.09 -0.09 -0.16 -0.2 -0.21 -0.32 c -0.05 -0.13 -0.08 -0.26 -0.08 -0.39 s 0.03 -0.26 0.08 -0.38 c 0.05 -0.12 0.12 -0.23 0.21 -0.33 c 0.09 -0.09 0.2 -0.16 0.33 -0.21 c 0.24 -0.1 0.52 -0.1 0.76 0 c 0.13 0.05 0.23 0.12 0.33 0.21 c 0.09 0.1 0.16 0.21 0.21 0.33 c 0.06 0.12 0.08 0.25 0.08 0.38 S 12.2 33.87 12.14 34 c -0.05 0.12 -0.12 0.23 -0.21 0.32 C 11.74 34.51 11.48 34.61 11.22 34.61 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,35,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 75.22 25.61 c -0.07 0 -0.13 0 -0.2 -0.02 c -0.06 -0.01 -0.12 -0.03 -0.18 -0.05 c -0.06 -0.03 -0.12 -0.06 -0.18 -0.1 c -0.051 -0.03 -0.101 -0.07 -0.15 -0.12 c -0.18 -0.18 -0.29 -0.44 -0.29 -0.71 c 0 -0.26 0.11 -0.52 0.29 -0.7 c 0.05 -0.05 0.1 -0.09 0.15 -0.13 c 0.06 -0.03 0.12 -0.07 0.18 -0.09 c 0.06 -0.03 0.12 -0.04 0.18 -0.06 c 0.33 -0.06 0.681 0.04 0.91 0.28 c 0.18 0.18 0.29 0.44 0.29 0.7 c 0 0.07 -0.01 0.13 -0.02 0.2 c -0.011 0.06 -0.03 0.13 -0.061 0.19 c -0.02 0.06 -0.05 0.11 -0.09 0.17 c -0.04 0.05 -0.08 0.1 -0.12 0.15 C 75.74 25.51 75.479 25.61 75.22 25.61 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,35,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 27.22 7.61 c -0.26 0 -0.52 -0.1 -0.71 -0.29 c -0.18 -0.19 -0.29 -0.44 -0.29 -0.71 c 0 -0.13 0.03 -0.26 0.08 -0.38 C 26.35 6.11 26.42 6 26.51 5.9 c 0.38 -0.37 1.05 -0.37 1.42 0 c 0.09 0.1 0.16 0.21 0.21 0.33 c 0.05 0.12 0.08 0.25 0.08 0.38 c 0 0.26 -0.11 0.52 -0.29 0.71 C 27.74 7.51 27.48 7.61 27.22 7.61 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,35,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.c7e98df2b2f837fd1ecc45ba267d5e7e.svg";
export { ForwardRef as ReactComponent };